import React from 'react';

const All: React.FC<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} {...props}>
    <path
      d="M19.91 11.704c.316 0 .572.256.572.571v14.768a.572.572 0 01-.571.572H5.143a.572.572 0 01-.572-.572V12.275c0-.315.256-.571.572-.571zm-.57 1.142H5.713V26.47H19.34V12.846zm4.27-4.842c.28 0 .513.202.562.469l.009.103v14.769a.571.571 0 01-1.134.103l-.009-.103V9.146l-14.196.001a.573.573 0 01-.563-.469l-.009-.102c0-.28.202-.514.469-.563l.103-.009H23.61zm3.434-3.433c.28 0 .514.202.562.469l.01.103v14.59a.571.571 0 01-1.134.102l-.01-.103V5.713l-14.196.001a.571.571 0 01-.562-.469l-.01-.102c0-.28.202-.514.47-.563l.102-.009h14.768z"
      fillRule="evenodd"
    />
  </svg>
);

export default All;
